import useMediaQuery from './useMediaQuery';

/**
 * 主たる入力機器が「粗いポインタ」（＝指）かどうか。
 *
 * ホバーが無い環境ではホバー前提のアフォーダンス（表示されない削除ボタン等）が
 * 成立しないため、そこだけ挙動を変えたいときに使う。CSSの
 * `@media (pointer: coarse)` と同じ条件。
 */
export default function useCoarsePointer() {
  return useMediaQuery('(pointer: coarse)');
}
